import {useMutation} from 'react-query';
import {postSubBrandImage} from '.';

const usePostSubBrandImage = () => {
  const {mutateAsync, isLoading} = useMutation({
    mutationFn: (payload: FormData) => {
      return postSubBrandImage(payload);
    },
  });

  return {mutateAsync, imagesLoading: isLoading};
};

export default usePostSubBrandImage;
